import env from 'config/env'

export const PURPOSE_METADATA = Object.freeze({
  title: 'Purpose @ Pomelo Fashion - Pomelo',
  titleKey: 'PURPOSE_META_TITLE',
  description:
    'Shop the latest fashion at POMELO fashion. Designed and manufactured in house for quality and style. Dresses, tops, knits, jackets, denim, accessories and more!',
  descriptionKey: 'PURPOSE_META_DESC',
})

export const PURPOSE_SHARED = Object.freeze({
  categoryId: 1570,
  shopCollectionHref: '/category?id=1570',
  shopCollectionAs: 'clothes/purpose-19-collection',
})

export const PURPOSE_LOOKBOOK = Object.freeze({
  categoryId: 1782,
  lookbookHref: '/lookbook?id=1782',
  lookbookAs: 'lookbooks/lookbook-wonder-flower',
})

export const PURPOSE_HERO_AND_DESC = Object.freeze({
  heroImg: [
    {
      ratio: 1,
      src: `${env.IMG_HOST}img/purpose-19/hero_m.jpg`,
    },
    {
      ratio: 0.5625,
      src: `${env.IMG_HOST}img/purpose-19/hero_d.jpg`,
    },
  ],
  titleImg: [
    {
      ratio: 0.244252874,
      src: `${env.IMG_HOST}img/purpose-19/title_m.svg`,
    },
    {
      ratio: 0.244252874,
      src: `${env.IMG_HOST}img/purpose-19/title_d.svg`,
    },
  ],
  ourStoryImg: [
    {
      ratio: 0.66625,
      src: `${env.IMG_HOST}img/purpose-19/m_purpose_our-story.jpg`,
    },
    {
      ratio: 0.66625,
      src: `${env.IMG_HOST}img/purpose-19/w_purpose_our-story.jpg`,
    },
  ],
  ourStory: 'our story',
  ourStoryKey: 'PURPOSE_HEAD_OUR_STORY',
  desc: 'Founded in 2018, Purpose by Pomelo aims to change the way fast fashion impacts our planet. By continuously adopting a sustainable mindset, we strive towards a better future. Our latest collection brings eco-friendly fabrics to life with BCI cotton, linen, hemp, and more, while fulfilling our mission even further through the use of natural dyes and adopting more sustainable processes. By collaborating with independent shoe brand, Oyster, Pomelo is making vegan leather shoes available for all.',
  descKey: 'PURPOSE_HEAD_DESC',
  shopCollection: 'shop collection',
  shopCollectionKey: 'PURPOSE_HEAD_SHOP_COLLECTION',
})

export const PURPOSE_IMAGE_GROUP = Object.freeze({
  imagesRatio: 0.66625,
  images: [
    {
      src: `${env.IMG_HOST}img/purpose-19/w_purpose_fabrics.jpg`,
      desc: 'Committed to making sustainable fabrics part of your lifestyle',
      descKey: 'PURPOSE_IMAGE_GROUP_1',
    },
    {
      src: `${env.IMG_HOST}img/purpose-19/w_purpose_natural.jpg`,
      desc: 'Natural colors used in dyeing process',
      descKey: 'PURPOSE_IMAGE_GROUP_2',
    },
    {
      src: `${env.IMG_HOST}img/purpose-19/w_purpose_leather.jpg`,
      desc: 'Vegan leather shoes crafted from biodegradable microfibre',
      descKey: 'PURPOSE_IMAGE_GROUP_3',
    },
  ],
  subtitle: 'Wear the change fashion needs.',
  subtitleKey: 'PURPOSE_IMAGE_GROUP_DESC',
  lookbook: 'view lookbook',
  lookbookKey: 'PURPOSE_LOOKBOOK',
})

export const PURPOSE_SHOP_COLLECTION = Object.freeze({
  image: [
    {
      ratio: 1.25,
      src: `${env.IMG_HOST}img/purpose-19/m_purpose_collection.jpg`,
    },
    {
      ratio: 0.66625,
      src: `${env.IMG_HOST}img/purpose-19/w_purpose_collection.jpg`,
    },
  ],
  desc: 'purpose collection',
  descKey: 'PURPOSE_SHOP_COLLECTION_DESC',
  subtitle: 'Wear the change fashion needs. Green your wardrobe!',
  subtitleKey: 'PURPOSE_SHOP_COLLECTION_SUBTITLE',
  cta: "shop purpose '19",
  ctaKey: 'PURPOSE_SHOP_COLLECTION_CTA',
})

export const PURPOSE_JOIN_DONATE = Object.freeze({
  image: {
    ratio: 1,
    src: `${env.IMG_HOST}img/purpose-19/w_purpose_donate.jpg`,
    desc: 'join the revolution today.',
    descKey: 'PURPOSE_JOIN_DONATE_IMG_DESC',
  },
  title: "Here's How:",
  titleKey: 'PURPOSE_JOIN_DONATE_TITLE',
  subtitle:
    'Book a free pick up service for your clothing donations for a period of one month or donate in person at one of our drop-off locations.',
  subtitleKey: 'PURPOSE_JOIN_DONATE_SUBTITLE',
  cta: 'donate now',
  ctaKey: 'PURPOSE_JOIN_DONATE_CTA',
  ctaAs: 'pomelofashion://deeplink/purpose',
  ctaHref: 'pomelofashion://deeplink/purpose',
})
